export default "__VITE_ASSET__zE_P7ROV__"